import React, { useContext } from 'react';

import cx from 'classnames';

import LandingPageContext from 'components/shared/LandingPage/contexts/LandingPageContext';
import { useScrollOffset } from 'hooks/useScrollOffset';
import { LANDING_THEMES } from 'utils/itineraries/functions';

import useMobileNav from './functions';
import s from './index.module.css';
import Item from './Item';

function MobileNav({ links = [], navigation, unlock }) {
  const { onActive } = useMobileNav();
  const { isItinerariesItem, isPortal, hasHeader, isPortalItinerary, landingTheme } = useContext(LandingPageContext);
  const { clickOffset, baseOffset } = useScrollOffset({ isItinerariesItem, isPortal, landingTheme, hasHeader });

  return (
    <>
      <div
        className={cx(
          navigation && s.navigation,
          landingTheme === LANDING_THEMES.default && s.navigationMargin,
          unlock && s.unlockNavigation,
          s.wrapper,
          'custom-landing-page-mobile-nav',
        )}
        id="mobileNav"
      >
        {links.map((link, i) => (
          <Item
            key={i}
            index={i}
            link={link}
            baseOffset={baseOffset}
            clickOffset={clickOffset}
            onActive={onActive}
            isPortalItinerary={isPortalItinerary}
          />
        ))}
      </div>
      <div className={landingTheme === LANDING_THEMES.default && s.border}></div>
    </>
  );
}

export default MobileNav;
